<div class="abandonedReservationBody">
  <div class="abandonedReservationBody__img" *ngIf="hasImage">
    <ng-content select="[image]"></ng-content>
  </div>
  <ng-content select="[content]"></ng-content>
</div>